import { useEffect } from 'react';

import { debounce } from '../lib/debounce';

export const useResizeListener = (hideLabelsOnOverflow: boolean, updateMenu: () => void) => {
  useEffect(() => {
    if (!hideLabelsOnOverflow) return;
    const debounceUpdateMenu = debounce(updateMenu, 300);
    window.addEventListener('resize', debounceUpdateMenu);

    return () => window.removeEventListener('resize', debounceUpdateMenu);
  }, [hideLabelsOnOverflow, updateMenu]);
};
